export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'qinggan-duben',
    name: '情感读本',
    description: '细腻动人的情感故事，用文字温暖每一颗心灵',
    icon: 'ri-heart-line',
  },
  {
    slug: 'shige-zatan',
    name: '诗歌杂谈',
    description: '以诗为媒，畅谈人生百味与细腻情思',
    icon: 'ri-quill-pen-line',
  },
  {
    slug: 'shenye-diantai',
    name: '深夜电台',
    description: '夜色中的文字慰藉，陪伴每一个不眠的灵魂',
    icon: 'ri-moon-line',
  },
  {
    slug: 'qinglv-jiaoliu',
    name: '情侣交流',
    description: '甜蜜浪漫的二人世界，用文字编织爱的诗篇',
    icon: 'ri-heart-2-line',
  },
  {
    slug: 'xinling-chengzhang',
    name: '心灵成长',
    description: '在文字中探索自我，收获内心的宁静与力量',
    icon: 'ri-plant-line',
  },
  {
    slug: 'wenyi-shenghuo',
    name: '文艺生活',
    description: '分享生活中的美好瞬间，用文字记录诗意日常',
    icon: 'ri-camera-line',
  },
];